// ATUALMENTE UTILIZANDO PARA BALANÇA E TOMADA. SE FUTURAMENTE PRICISAR DE STATUS DIFERENTES, CRIAR OUTRO ARQUIVO

export const MovBalancaStatus = {
  Pending: {
    label: 'Em Andamento',
    color: '#FDC00F',
  },
  Finished: {
    label: 'Finalizada',
    color: '#3ac2bb',
  },
}
export default function (status) {
  for (const key in MovBalancaStatus) {
    const s = MovBalancaStatus[key]
    if (s.label === status) return MovBalancaStatus[key]
  }
}
